export default "__VITE_ASSET__DqHIW5PY__"